<div class="mt-4 mb-3">
  <div *ngIf="hasCirculation()">
    <p *ngFor="let data of results">
      <a *ngIf="data.assetTypeId == 5" class="tittle1" rel="noopener noreferrer" (click)="onMedialinkClick(data.url)" style="display:block"> {{data.assetName}}.pdf</a>
    </p>
  </div>
  <div class="tittle1 font-weight-bold" *ngIf="!hasCirculation()">No Circulation</div>
</div>